import { render, staticRenderFns } from "./addToCallViewer.vue?vue&type=template&id=620518ae"
import script from "./addToCallViewer.vue?vue&type=script&lang=js"
export * from "./addToCallViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports